import { applyHousekeepingWrite as e } from "./invalidateHousekeeping.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { housekeepingApi as r } from "@maat/api-main";
//#region src/housekeeping/useSetRoomHousekeepingStatusMutation.ts
var i = (i) => {
	let a = n();
	return t({
		mutationFn: ({ unitId: e, payload: t }) => r.setRoomStatus(i, e, t),
		onSuccess: (t) => e(a, i, [t])
	});
};
//#endregion
export { i as useSetRoomHousekeepingStatusMutation };
